var h = Object.defineProperty;
var c = (o, t, n) => t in o ? h(o, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[t] = n;
var u = (o, t, n) => c(o, typeof t != "symbol" ? t + "" : t, n);
const s = {
  /** 切り上げ */
  RoundUp: "RoundUp",
  /** 四捨五入 */
  Round: "Round",
  /** 切り捨て */
  RoundDown: "RoundDown"
}, i = class i {
  // -----------------------------------------------------------
  // GB/MB/KB/Bytes自動変換（少数第2位まで表示）
  // -----------------------------------------------------------
  static ConvStorage(t) {
    let n = "";
    return t >= this.DEF_COMV_STOREGE_GB ? n = this.ConvStorageGB(t) : t >= this.DEF_COMV_STOREGE_MB ? n = this.ConvStorageMB(t) : t >= this.DEF_COMV_STOREGE_KB ? n = this.ConvStorageKB(t) : n = String(t) + "Bytes", n;
  }
  /**
   * 指定サイズをKB単位で変換する。
   * @param llSize サイズ
   * @param decimalPlaces 少数第何位
   * @param roundType ラウンドタイプ
   */
  static ConvStorageKB(t, n = 2, e = s.RoundDown) {
    let r = t / (this.DEF_COMV_STOREGE_KB * 1);
    return r = i.roundValue(r, n, e), r.toFixed(n).toString() + "KB";
  }
  /**
   * 指定サイズをMB単位で変換する。
   * @param llSize サイズ
   * @param decimalPlaces 少数第何位
   * @param roundType ラウンドタイプ
   */
  static ConvStorageMB(t, n = 2, e = s.RoundDown) {
    let r = t / (this.DEF_COMV_STOREGE_MB * 1);
    return r = i.roundValue(r, n, e), r.toFixed(n).toString() + "MB";
  }
  /**
   * 指定サイズをGB単位で変換する。
   * @param llSize サイズ
   * @param decimalPlaces 少数第何位
   * @param roundType ラウンドタイプ
   */
  static ConvStorageGB(t, n = 3, e = s.RoundDown) {
    let r = t / (this.DEF_COMV_STOREGE_GB * 1);
    return r = i.roundValue(r, n, e), r.toFixed(n).toString() + "GB";
  }
  /**
   * 指定された小数点以下の桁数で数値を丸める関数
   * @param value 値
   * @param decimalPlaces 少数第何位まで残すか
   * @param roundType 丸め方法
   * @returns 丸めた後の値
   */
  static roundValue(t, n, e) {
    if (n < 0)
      return t;
    const r = Math.pow(10, n);
    switch (e) {
      case s.Round:
        return Math.round(t * r) / r;
      case s.RoundUp:
        return Math.ceil(t * r) / r;
      case s.RoundDown:
        return Math.floor(t * r) / r;
      default:
        return t;
    }
  }
};
u(i, "DEF_COMV_STOREGE_GB", 1024 * 1024 * 1024), u(i, "DEF_COMV_STOREGE_MB", 1024 * 1024), u(i, "DEF_COMV_STOREGE_KB", 1024);
let _ = i;
function f(o) {
  return typeof o == "string" ? 0 < o.length ? [o] : [] : o;
}
function V(o) {
  return o.toString(2).split("").reverse().map((t, n) => t === "1" ? n : -1).filter((t) => t !== -1);
}
class E {
  /**
   * コンストラクタをprivateにすることで、
   * 不正な値でのインスタンス化を防ぎ、
   * 静的ファクトリメソッドの使用を強制します。
   */
  constructor(t) {
    // IPv4アドレスを数値化したもの
    u(this, "_intValue");
    this._intValue = t;
  }
  /**
   * IPv4形式の文字列からインスタンスを生成します。
   * @param ip - "192.168.1.1" のようなIPv4形式の文字列。
   * @returns Ipv4Addressの新しいインスタンス。
   */
  static fromString(t) {
    const n = t.split(".");
    if (n.length !== 4)
      throw new Error("Invalid IPv4 format: The address must contain 4 octets.");
    const e = n.reduce((r, d) => {
      const a = parseInt(d, 10);
      if (isNaN(a) || a < 0 || a > 255)
        throw new Error(`Invalid IPv4 format: Octet "${d}" is invalid.`);
      return (r << 8) + a;
    }, 0);
    return new E(e >>> 0);
  }
  /**
   * 32ビット符号なし整数からインスタンスを生成します。
   * @param intValue - 32ビット符号なし整数。
   * @returns Ipv4Addressの新しいインスタンス。
   */
  static fromInt(t) {
    if (t < 0 || t > 4294967295)
      throw new Error("Invalid integer value for an IPv4 address.");
    return new E(t);
  }
  /**
   * 32ビット符号なし整数として値を取得します。
   */
  toInt() {
    return this._intValue;
  }
  /**
   * IPv4形式の文字列として値を取得します。
   */
  toString() {
    return [
      this._intValue >>> 24,
      this._intValue >>> 16 & 255,
      this._intValue >>> 8 & 255,
      this._intValue & 255
    ].join(".");
  }
  /**
   * 2つのIPアドレスが等しいか比較します。
   * @param other - 比較対象のIpv4Addressインスタンス。
   */
  equals(t) {
    return this._intValue === t._intValue;
  }
}
export {
  _ as C,
  E as I,
  s as R,
  V as a,
  f as t
};
